import React from 'react';

import styles from './PickupTimeline.module.scss';
import { PickupTimelineStep, PickupTimelineStepProps } from './PickupTimelineItem';

export interface PickupTimelineProps {
  pickupTimelineSteps: PickupTimelineStepProps[];
}

export const PickupTimeline: React.FC<PickupTimelineProps> = ({
  pickupTimelineSteps,
}) => (
  <div className={styles['pickup-timeline']}>
    {pickupTimelineSteps.map((step) => (<PickupTimelineStep key={step.title} {...step} />))}
  </div>
);
